module.exports = __webpack_public_path__ + "static/media/auditing.df0ae315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/auditing.png
// module id = 1604
// module chunks = 0